'use strict';
var $ = require('jquery'),
  Backbone = require('backbone'),
  FiveYearsOut = Backbone.View.extend({
    initialize: function() {
      this.$el.find('.FiveYearsOut-item--animation img').one('load', () => {
        this.setPositionDot()
      })
      $(window).on('scroll resize', () => {
        this.setPositionDot()
      })
    },
    setPositionDot() {
      const $item  = this.$el.find('.FiveYearsOut-item')
      $item.each((_ind , e) => {
        let heightImage = $(e).find('img').innerHeight() / 2;
        $(e).find('.FiveYearsOut-item--dot').css('top', heightImage);
      })
    }
  }, {
    create: function create($parent) {
      $parent.find('.FiveYearsOut').each((n, el) => {
        new FiveYearsOut({
          el: el
        });
      });
    }
  });

module.exports = FiveYearsOut;


// WEBPACK FOOTER //
// ./assets/components/FiveYearsOut/FiveYearsOut.js